export default __webpack_public_path__ + "static/media/ipet04.946cd7f2.png";